import { Theme } from "@mui/material/styles";
import createImageProps from "../components/image/createImageProps";
import createVideoProps from "../components/video/createVideoProps";
import {
  Props as VideoData,
  VideoGallerySlide
} from "../components/video/types";
import type { MediaData } from "@bmi-digital/components/media-gallery";
import type { ImageGallerySlide } from "../components/image/types";

export const getJpgImage = (ogImageUrl: string | undefined | null) => {
  if (!ogImageUrl) {
    return;
  }

  let url = ogImageUrl;

  if (ogImageUrl.startsWith("//")) {
    url = "https:" + ogImageUrl;
  }

  // required by Meta: https://developers.facebook.com/docs/sharing/webmasters/#images
  if (url.includes("//images.ctfassets.net/") && !url.includes("fm=")) {
    return `${url}${url.includes("?") ? "&" : "?"}fm=jpg`;
  }

  return url;
};

export type GalleryPimVideo = Omit<VideoData, "previewMedia" | "videoRatio"> & {
  __typename: "PimVideo";
  previewMedia: null;
  videoRatio: null;
};

export type GallerySectionMedias =
  | ImageGallerySlide
  | VideoGallerySlide
  | GalleryPimVideo;

export const transformMediaSrc = (
  media: readonly GallerySectionMedias[],
  theme: Theme
): MediaData[] => {
  return media.map((item) => {
    if (!("collectionType" in item)) {
      return {
        media: createVideoProps(item, theme),
        thumbnail: item.defaultYouTubePreviewImage,
        caption: item.title || undefined,
        isVideo: true
      };
    }
    if (item.collectionType === "image") {
      return {
        media: createImageProps(item, theme),
        thumbnail: item.sizes.thumbnail.url,
        caption: item.caption || undefined,
        altText: item.altText || undefined,
        isVideo: false
      };
    }

    return {
      media: createVideoProps(item, theme),
      thumbnail:
        item.previewMedia?.sizes.thumbnail.url ||
        item.defaultYouTubePreviewImage,
      caption: item.subtitle || undefined,
      altText: item.label,
      isVideo: true
    };
  });
};
